import React from "react";
import {
  Autocomplete,
  Box,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import DatePicker from "react-datepicker";
import { useSelector } from "react-redux";
import { ReactComponent as CalendarIcon } from "../../../assets/Images/CalendarIcon.svg";
import { commonStyles } from "../../../assets/MUIStyles/commonStyles";
import { dashboardStyles } from "../../../assets/MUIStyles/dashboard";
import { ReactComponent as RefreshIcon } from "../../../assets/icons/refresh.svg";
import BaseButton from "../Common/Buttons/BaseButton";

const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

const Heading = ({
  resetFilters,
  applyFilters,
  refreshLoading,
  refreshData,
  selectedState,
  setSelectedState,
}) => {
  const {
    ProjectReducer: { projectList },
  } = useSelector((state: any) => state);

  const { selectedProject, selectedDateRange } = selectedState;
  const [startingDate, endingDate] = selectedDateRange;

  return (
    <Box className="flex-between-only">
      <Typography className="font-20-grey">Dashboard</Typography>
      <Box className="flex-between-only gap-1" sx={{ height: 36 }}>
        <Autocomplete
          options={projectList}
          getOptionLabel={(option) => option?.projectName}
          value={projectList?.find((p) => p?._id === selectedProject) || null}
          onChange={(event, newValue) =>
            setSelectedState((prev) => ({
              ...prev,
              selectedProject: newValue?._id || "",
            }))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Select Project"
              sx={{
                ...commonStyles.inputField,
                width: "170px",
                "& .MuiAutocomplete-input": {
                  padding: "8px 5px 8px 15px !important",
                },
              }}
            />
          )}
          disablePortal={true}
        />
        <Box sx={dashboardStyles.calendarContainer}>
          <DatePicker
            dateFormat="dd/MM/yyyy"
            selectsRange
            maxDate={addDays(new Date(), 0)}
            startDate={startingDate}
            endDate={endingDate}
            onChange={(updated) =>
              setSelectedState((prev) => ({
                ...prev,
                selectedDateRange: updated,
              }))
            }
            placeholderText="From date - To date"
            className="custom-date-input"
          />
          <CalendarIcon className="calendar-icon" />
        </Box>
        <BaseButton
          variant="contained"
          title="Apply"
          disabled={
            refreshLoading ||
            (!selectedProject && (!startingDate || !endingDate))
          }
          handleClick={applyFilters}
        />
        <BaseButton
          variant="outlined"
          title="Reset"
          disabled={refreshLoading}
          handleClick={resetFilters}
        />

        <IconButton
          title="Refresh"
          onClick={refreshData}
          sx={{
            ...commonStyles.refreshButtonStyle,
            ...dashboardStyles.refreshAnimation(refreshLoading),
          }}
          disabled={refreshLoading}
        >
          <RefreshIcon className="refresh-icon" height={14} width={14} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Heading;
